<template>
    <div v-if="popupData">
        <vs-card v-for="(statuses, index) of popupData" :key="index">
            <div v-for="(statusDate, key) of statuses" :key="key">
                <div class="text" v-for="(status, name) of getParseStatus(statusDate)" :key="name">
                    <span v-if="status">{{status}}</span>
                    <span v-else>-</span>
                </div>
                <div class="flex justify-end date">
                    <span>{{key | getDate}}</span>
                    <span class="ml-2">{{key |  getTime}}</span>
                </div>
            </div>
        </vs-card>
    </div>
    <div v-else class="text-center text-2xl">
        {{$t('global.No_data')}}
    </div>
</template>

<script>
import {getDate} from '@/utils/mixins'

export default {
    name: 'LeadHistoryStatuses',
    props: ['popupData'],
    mixins: [getDate],
    methods:{
        getParseStatus(status) {
            return typeof status === 'string' ? JSON.parse(status) : status
        }
    },
    mounted() {
        this.$store.commit('UPDATE_LOADER_STATE', false)
    }
}
</script>

<style lang="scss" scoped>
.text {
    font-size: 13px;
}
.date {
    color: gray;
}
</style>
